<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      :overlay="false"
      max-width="900px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title primary-title>
          <div class="d-flex align-center">
            <!-- <div class="" style="width: 230px">
              审批占总比:
            </div>
            <v-progress-linear v-model="allTotal" color="light-green darken-1" height="20" rounded>
              <template v-slot:default="{ value }">
                <span style="font-size: 15px">{{ allTotal }}%</span>
              </template>
            </v-progress-linear>-->
          </div>
        </v-card-title>

 
        <v-card-text >
          <div style="margin-bottom: 5px">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="查询需求名称"
              single-line
              hide-details
              @keydown="keydownSearch"
            ></v-text-field>
          </div>
           
          <div style="text-align: right;">
            
          <!-- *********************优先级***************************** -->
          <v-menu transition="slide-y-transition" offset-y nudge-bottom="5" :close-on-click="true">
            <template v-slot:activator="{ on, attrs, value }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                style="margin-top: 15px"
                class="md-button md-success dropdown-toggle deviceFilter"
              >
                {{ priority.name }}
                <v-icon :class="['ni', value ? 'rotate-180' : '']"
                  >ni ni-bold-down text-xs ms-1</v-icon
                >
                <!-- <md-tooltip md-direction="top">优先级</md-tooltip> -->
              </v-btn>
            </template>

            <v-list class="py-1" dense max-height="300">
              <v-list-item-group active-class="v-List-actived" mandatory color="indigo">
                <v-list-item
                  class="list-item-hover-active py-0 text-center"
                  v-for="(item, index) in priorityList"
                  :key="index"
                  @click="priorityType(item)"
                >
                  <v-list-item-content class="pa-0">
                    <v-list-item-title
                      v-text="item.name"
                      class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                    >
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
          <!-- *********************优先级***************************** -->

          <!-- *********************状态***************************** -->
          <v-menu transition="slide-y-transition" offset-y nudge-bottom="5" :close-on-click="true">
            <template v-slot:activator="{ on, attrs, value }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                style="margin-top: 15px"
                class="md-button md-success dropdown-toggle deviceFilter"
              >
                {{ statusData.name }}
                <v-icon :class="['ni', value ? 'rotate-180' : '']"
                  >ni ni-bold-down text-xs ms-1</v-icon
                >
                <!-- <md-tooltip md-direction="top">优先级</md-tooltip> -->
              </v-btn>
            </template>

            <v-list class="py-1" dense max-height="300">
              <v-list-item-group active-class="v-List-actived" mandatory color="indigo">
                <v-list-item
                  class="list-item-hover-active py-0 text-center"
                  v-for="(item, index) in btnStatus"
                  :key="index"
                  @click="statusType(item)"
                >
                  <v-list-item-content class="pa-0">
                    <v-list-item-title
                      v-text="item.name"
                      class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                    >
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
          <!-- ***********************状态*************************** -->

          </div>
          <v-data-table
            :headers="headers"
            :items="desserts"
            class="elevation-1 tableWrap"
            hide-default-footer
          >
            <!-- <template v-slot:item.model_priority="{ item }">
              <v-btn
                class="md-button"
                :style="{
                background: setPriorityColor(item),
              }"
              >
                  {{ setPriorityName(item.model_priority) }}
              </v-btn>
            </template> -->
            <template #[`item.model_priority`]="{ item }">
              <v-menu
              v-if="item.status==8||item.status==9||item.status==10"
                transition="slide-y-transition"
                offset-y
                nudge-bottom="5"
                :close-on-click="true"
              >
                <template v-slot:activator="{ on, attrs, value }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="md-button dropdown-toggle"
                    :style="{
                      background: setPriorityColor(item),
                    }"
                  >
                    {{ setPriorityName(item.model_priority) }}
                    <v-icon :class="['ni', value ? 'rotate-180' : '']"
                      >ni ni-bold-down text-xs ms-1</v-icon
                    >
                  </v-btn>
                </template>

                <v-list class="py-1" dense max-height="300">
                  <v-list-item-group active-class="v-List-actived" mandatory color="indigo">
                    <v-list-item
                      class="list-item-hover-active py-0 text-center"
                      v-for="(items, index) in model_priorityArr"
                      :key="items.code"
                      @click="changelPriority(item, items)"
                    >
                      <v-list-item-content class="pa-0">
                        <v-list-item-title
                          v-text="items.name"
                          class="text-body-2 ls-0 text-typo font-weight-600 mb-0 PriorityBtn"
                          :style="{ background: items.color }"
                        >
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu>
              <v-btn
              v-else
                class="md-button"
                :style="{
                background: setPriorityColor(item),
                width:'89px'
              }"
              >
                  {{ setPriorityName(item.model_priority) }}
              </v-btn>
              <!-- ************************************************** -->
            </template>

            <template v-slot:item.label="{ item }">
              <el-tooltip :content="item.label" placement="top" effect="light">
                <p class="labelWrap">{{ item.label }}</p>
              </el-tooltip>
            </template>
            <template v-slot:item.status="{ item }">
              <div
                :style="{
                  width: '100%',
                  lineHeight: '38px',
                  height: '38px',
                  color: '#fff',
                  backgroundColor: `${returnColor(item.status)}`,
                }"
              >
                {{ returnText(item.status) }}
              </div>
            </template>
            <template v-slot:item.producer="{ item }">
              <el-tooltip :content="item.label" placement="top" effect="light">
                <p class="producerWrap">{{ item.producer }}</p>
              </el-tooltip>
            </template>
            <template v-slot:item.created_at="{ item }">
              <span>{{ dateFormat(item.created_at) }}</span>
            </template>
            <template v-slot:item.caozuo="{ item }">
              <span style="margin-right: 20px; color: green; cursor: pointer" @click="review(item)"
                >查看</span
              >
              <span
                v-if="item.status == 8 || item.status == 9"
                style="cursor: pointer; color: red"
                @click="updateSubmit(item)"
                >修改需求</span
              >
              <span
                v-if="item.status == 10"
                style="cursor: pointer; color: red"
                @click="resetSubmit(item)"
                >重提需求</span
              >
            </template>
          </v-data-table>
          <div>
            <p style="float: left; height: 40px; line-height: 40px; margin: 0px">
              {{ statusTotal }} 共计 {{ pagination.total }} 条
            </p>
            <Pagination
              :page.sync="pagination.page"
              :total="pagination.total"
              :items-per-page.sync="pagination.itemsPerPage"
              @refresh="refreshResourceList"
              class="paginationWrap"
            />
          </div>
        </v-card-text>
        <v-card-actions >
            <div style="text-align: right;width:100%;">
            <v-btn color="gray" elevation="2" @click="close">关闭</v-btn>
          </div>
        </v-card-actions>
     
  
      </v-card>

      <viewDialog
        isView="模型申请"
        @closeViewDialog="closeViewDialog"
        :viewDialogVisible="viewDialogVisible"
        v-if="viewDialogVisible"
        :viewDialogData="viewDialogData"
      ></viewDialog>
    </v-dialog>

    <!-- <modelDialog1
      v-if="dialogVisible"
      :dialogVisible="dialogVisible"
      @closeDialog="closeDialog"
      :form="formData"
    ></modelDialog1>-->

    <modelDialogWrap
      v-if="dialogVisible"
      :dialogVisible="dialogVisible"
      :form="formData"
      @closeDialog="closeDialog"
    ></modelDialogWrap>
  </div>
</template>
<script>
import { getByTaskIdqueryModel, deleteModel,setModelPriority} from '@/api/model_resource';
// import modelDialog from '../../../DesignPage/Main/Action/modelResources/modelDialog.vue';
// import modelDialog1 from '../../../DesignPage/Main/Action/modelResources/modelDialog1.vue';
import modelDialogWrap from '../../../DesignPage/Main/Action/modelResources/modelDialogWrap.vue';
import Pagination from '@/components/Pagination/index';
import moment from 'moment';
import viewDialog from '../../../DesignPage/Main/Action/modelResources/view.vue';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    clickTaskId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      model_priorityArr: [
        {
          name: '最低',
          code: 1,
          color: '#73d897',
        },
        {
          name: '较低',
          code: 2,
          color: '#5dcfff',
        },
        {
          name: '普通',
          code: 3,
          color: '#f6c659',
        },
        {
          name: '较高',
          code: 4,
          color: '#ff9f73',
        },
        {
          name: '最高',
          code: 5,
          color: '#FF7575',
        },
      ],
      statusData: {
        name: '状态',
        status: '999',
      },
      priority: {
        name: '优先级',
        code: '1,2,3,4,5',
      },
      //优先级
      priorityList: [
        { code: '1,2,3,4,5', name: '全部' },
        { code: '1', name: '最低' },
        { code: '2', name: '较低' },
        { code: '3', name: '普通' },
        { code: '4', name: '较高' },
        { code: '5', name: '最高' },
      ],
      viewDialogVisible: false,
      viewDialogData: {},
      formData: {},
      dialogVisible: false,
      headers: [
        {
          text: '需求名称',
          align: 'left',
          sortable: false,
          value: 'label',
          filterable: true,
        },
        { text: '优先级', align: 'center', value: 'model_priority', sortable: false },
        { text: '制作状态', width: '100', align: 'center', value: 'status', sortable: false },
        { text: '制作人员', align: 'left', value: 'producer', sortable: false },
        { text: '创建时间', align: 'left', value: 'created_at', sortable: false },
        { text: '操作', width: '200', align: 'center', value: 'caozuo', sortable: false },
      ],
      desserts: [],
      skill: 100,
      // 分页
      pagination: {
        page: 1,
        itemsPerPage: 10,
        total: 0,
      },
      schedule: '', //进度
      search: '',
      btnStatus: [
        {
          id: '999',
          name: '全部',
          status: '999',
          colors: 'red',
        },

        {
          id: '8',
          name: '待审批',
          status: '8',
          colors: 'rgb(159,159,159)',
        },
        {
          id: '10',
          name: '审批驳回',
          status: '10',
          colors: 'rgb(255, 125, 125)',
        },
        {
          id: '9',
          name: '待制作',
          status: '9',
          colors: 'rgb(159,159,159)',
        },
        {
          id: '11',
          name: '制作中',
          status: '11',
          colors: 'rgb(0, 149, 255)',
        },
        {
          id: '12',
          name: '制作完成',
          status: '12',
          colors: 'rgb(76, 175, 80)',
        },
        {
          id: '13',
          name: '审核通过',
          status: '13',
          colors: 'rgb(76, 175, 80)',
        },
        {
          id: '14',
          name: '审核驳回',
          status: '14',
          colors: 'rgb(255, 125, 125)',
        },
      ],
      status: '999',
      toggle_exclusive: 0,
      id: 0,
      allTotal: 0,
    };
  },
  components: {
    Pagination,
    // modelDialog1,
    modelDialogWrap,
    viewDialog,
  },
  watch: {
    clickTaskId: {
      // 数据变化时执行的逻辑代码
      handler(id) {
        this.id = id;
        this.queryModelData();
      },
      // 开启深度监听
      deep: true,
    },
    dialog: {
      handler(news) {
        if (news) {
          this.pagination.page = 1;
        }else{
          this.statusData={
            name: '状态',
            status: '999',
          }
          this.priority={
            name: '优先级',
            code: '1,2,3,4,5',
          }
          this.desserts = [];
          this.refreshResourceList()

        }
      },
      deep: true,
    },
  },
  computed: {
    statusTotal() {
      let res = this.btnStatus.filter(item => item.status == this.statusData.status);
      return res[0].name;
    },
    dialog: {
      get() {
        return this.visible;
      },
      set(val) {
        if (!val) {
          this.$emit('close', val);
        }
      },
    },
  },
  mounted() {},
  methods: {
    changelPriority(item, items) {
      if (!item._id || !items.code) return;
      let params = {
        _id: item._id,
        model_priority: items.code,
      };
      setModelPriority(params).then(res => {
        if (res.code == '200') {
          this.$notify({
            timeout: 1500,
            message: '优先级设置成功!',
            icon: 'add_alert',
            horizontalAlign: 'center',
            verticalAlign: 'bottom',
            type: 'success',
          });
          this.refreshResourceList();
        }
      });
    },
    setPriorityColor(item) {
      // 1.最低  2.较低 3.普通 4.较高  5.最高
      if (item.model_priority == 1) {
        return '#73d897  !important';
      } else if (item.model_priority == 2) {
        return '#5dcfff  !important';
      } else if (item.model_priority == 3) {
        return '#f6c659  !important';
      } else if (item.model_priority == 4) {
        return '#ff9f73  !important';
      } else if (item.model_priority == 5) {
        return '#FF7575  !important';
      }
    },
    setPriorityName(code) {
      // 1.最低  2.较低 3.普通 4.较高  5.最高
      if (code == 1) {
        return '最低';
      } else if (code == 2) {
        return '较低';
      } else if (code == 3) {
        return '普通';
      } else if (code == 4) {
        return '较高';
      } else if (code == 5) {
        return '最高';
      }
    },
    statusType(item) {

      this.statusData = item;
      this.pagination.page = 1;
     this.refreshResourceList()
    },
    //优先级
    priorityType(item) {
      this.priority = item;
      this.pagination.page = 1;
      // this.status = status;
      this.refreshResourceList();
    },
    close() {
      this.dialog = false;
      this.desserts = [];
    },
    closeViewDialog() {
      this.viewDialogVisible = false;
    },
    //查看
    review(item) {
      this.viewDialogVisible = true;
      this.viewDialogData = item;
    },
    resetSubmit(item) {
      this.formData = item;
      this.dialogVisible = true;
    },
    updateSubmit(item) {
      this.formData = item;
      this.dialogVisible = true;
    },
    closeDialog() {
      this.dialogVisible = false;
      this.queryModelData();
    },
    // changeStatus({ status }) {
    //   this.status = status;
    //   this.queryModelData();
    // },
    //状态, 8:需求申请, 9:审批同意, 10:审批驳回, 9待制作  11:制作中, 12:制作完成, 13:审核通过 14:审核驳回,
    returnColor(status) {
      let res = this.btnStatus.filter(item => item.status == status);
      return res[0]['colors'];
    },
    returnText(status) {
      let res = this.btnStatus.filter(item => item.status == status);
      return res[0]['name'];
    },
    dateFormat(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    /**
     * 查询列表
     */
    refreshResourceList() {
      this.queryModelData();
    },
    /**
     * 搜索框点击enter事件
     */
    keydownSearch(e) {
      // 点击Enter
      if (e.keyCode === 13) {
        this.queryModelData();
      }
    },
    queryModelData() {
      if (!this.id) return;
      let params = {
        taskId: this.id,
        perPage: this.pagination.itemsPerPage,
        currentPage: this.pagination.page,
        name: this.search,
        status: this.statusData.status||'', //状态
        priority:this.priority.code||''
      };

      getByTaskIdqueryModel(params).then(res => {
        if (res.code == '200') {
          this.desserts = res.data.row;
          this.pagination.total = res.data.total;
          this.schedule = res.data.schedule;
          this.allTotal = ((this.schedule / res.data.allTotal) * 100).toFixed(2);
        }
      });
    },
  },
  created() {},
};
</script>

<style scoped>

.PriorityBtn {
  padding: 5px;
  border-radius: 12px;
  color: #fff !important;
}

>>> .tableWrap {
  min-height: 518px !important;

}
.paginationWrap {
  padding: 10px !important;
}
>>> .tableWrap td {
  height: 38px !important;
  line-height: 38px !important;
}
/* .toggleWrap .v-btn{
   height: 26px !important;
} */
.labelWrap {
  width: 160px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.producerWrap {
  width: 70px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.v-application p{
  margin-bottom: 0px;
}
</style>
